export type DesktopTheme = 'light' | 'dark';
export const DESKTOP_THEME_KEY = 'hkmeeting-theme';

export const resolveDesktopTheme = (preference: string | null, systemDark: boolean): DesktopTheme =>
  preference === 'light' || preference === 'dark' ? preference : systemDark ? 'dark' : 'light';

export const readThemePreference = (): string | null => {
  try {
    return localStorage.getItem(DESKTOP_THEME_KEY);
  } catch {
    return null;
  }
};

export const applyDesktopTheme = (theme: DesktopTheme) => {
  document.documentElement.dataset.desktopTheme = theme;
  document.body.setAttribute('arco-theme', theme);
  document.documentElement.style.colorScheme = theme;
};

// Runs when the root module loads, before React paints the desktop shell.
export const initializeDesktopTheme = () => {
  const theme = resolveDesktopTheme(readThemePreference(), window.matchMedia('(prefers-color-scheme: dark)').matches);
  applyDesktopTheme(theme);
  return theme;
};
